export default __webpack_public_path__ + "static/media/hht1_ep01_timeline_q05_b.b08e2911.png";